import { isCooldownReady } from './cooldown';
import type { BattleSide, BattleState } from './types';

function getActive(state: BattleState, side: BattleSide) {
  return side === 'player' ? state.player : state.opponent;
}

/**
 * Temporary aut cast stub until `battle/ai/*` exists.
 * Picks the first move in kit order that passes global and per-move CD gates.
 * Used for both sides in `runSimulatedBattle` / `pnpm sim`. Product Mini App player
 * input must call `tryCastMove('player', …)` from UI — do not call this for player there.
 */
export function pickStubNpcMove(state: BattleState, side: BattleSide): string | null {
  const mon = getActive(state, side);
  if (!isCooldownReady(mon.globalRemainingCd)) return null;
  for (const moveId of mon.moveIds) {
    if (isCooldownReady(mon.cooldowns.remainingCd[moveId] ?? 0)) {
      return moveId;
    }
  }
  return null;
}
